import React, { useCallback, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Input, Layout, Select } from '../../../components';
import { useToast } from '../../../hooks/toast';
import { RoutesPaths } from '../../../routes';
import api from '../../../services/api';
import type { CriticalMessageData } from '../../../shared/interfaces/criticalMessage';
import getValidationErrors from '../../../utils/getValidationErrors';
import ProductsOptions from './../products';
import CriticalTypeOptions from './../tiposValidacao';
import { FormContainer, FormFooter } from './styles';

const Cadastro: React.FC = () => {
  const formRef = useRef<FormHandles | null>(null);
  const history = useHistory();
  const location = useLocation();
  const { addToast } = useToast();
  let selectedProducts = useRef<string[]>([]);
  let selectedCriticalType = useRef<string[]>([]);

  function back() {
    if (location.pathname.match('/listar')) {
      history.push(RoutesPaths.home);
    } else {
      history.goBack();
    }
  }

  const handleSubmit = useCallback(async (data: CriticalMessageData) => {
    data.tiposValidacaoCritica = selectedCriticalType.current;
    data.tiposValidacao = selectedProducts.current;
    try {
      // eslint-disable-next-line no-self-assign
      data.tiposValidacao = data.tiposValidacao;
      if (!data.tiposValidacaoCritica?.length && !data.tiposValidacao?.length) {
        const schemaSelect = Yup.object().shape({
          chave: Yup.string()
            .max(200, 'No máximo 200 caracteres')
            .required('Este campo é obrigatório!'),
          mensagem: Yup.string()
            .max(400, 'No máximo 400 caracteres')
            .required('Este campo é obrigatório!'),
          select1: Yup.string().required('Este campo é obrigatório!'),
          select: Yup.string().required('Este campo é obrigatório!'),
        });

        await schemaSelect.validate(data, {
          abortEarly: false,
        });
      }
      if (!data.tiposValidacaoCritica?.length) {
        const schemaSelect = Yup.object().shape({
          chave: Yup.string()
            .max(200, 'No máximo 200 caracteres')
            .required('Este campo é obrigatório!'),
          mensagem: Yup.string()
            .max(400, 'No máximo 400 caracteres')
            .required('Este campo é obrigatório!'),
          select1: Yup.string().required('Este campo é obrigatório!'),
        });

        await schemaSelect.validate(data, {
          abortEarly: false,
        });
      }
      if (!data.tiposValidacao?.length) {
        const schemaSelect = Yup.object().shape({
          chave: Yup.string()
            .max(200, 'No máximo 200 caracteres')
            .required('Este campo é obrigatório!'),
          mensagem: Yup.string()
            .max(400, 'No máximo 400 caracteres')
            .required('Este campo é obrigatório!'),
          select: Yup.string().required('Este campo é obrigatório!'),
        });

        await schemaSelect.validate(data, {
          abortEarly: false,
        });
      }
      const schema = Yup.object().shape({
        id: Yup.string().max(25, 'No máximo 25 caracteres'),
        chave: Yup.string()
          .max(200, 'No máximo 200 caracteres')
          .matches(
            /^(?!`´\s*$)[-a-zA-Z0-9:,.' ']/,
            'Um ou mais caracteres digitados não são permitidos!',
          )
          .required('Este campo é obrigatório!'),
        mensagem: Yup.string()
          .max(400, 'No máximo 400 caracteres')
          .matches(
            /^(?!\s*$)[-a-zA-Z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ_:,.' ']/,
            'Um ou mais caracteres digitados não são permitidos!',
          )
          .required('Este campo é obrigatório!'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post('/criticas', data);
      addToast({
        type: 'success',
        title: 'Mensagem de Critíca cadastrada com sucesso!',
        description:
          'As informações da Mensagem de Crítica foram cadastradas. Você pode verificar a nova Mensagem de Crítica na seção de Listagem de Mensagens de Críticas.',
      });

      setTimeout(() => {
        history.push(RoutesPaths.listCriticalMessage);
      }, 3000);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errorMessages = getValidationErrors(err);
        formRef.current?.setErrors(errorMessages);
        return;
      } else {
        console.error(err);
        addToast({
          type: 'error',
          title: 'Mensagem de Crítica já cadastrada!',
          description:
            'As informações que foram inseridas, já estão presentes no sistema.',
        });
      }
    }
  }, []);

  return (
    <>
      <Layout title={'Cadastro de Mensagem de Crítica'}>
        <FormContainer>
          <Form
            className="form-container"
            ref={formRef}
            onSubmit={handleSubmit}
          >
            <Input
              name="chave"
              label="Chave"
              type="text"
              data-testid={'form-field-key'}
            />
            <Input
              name="mensagem"
              label="Mensagem"
              type="text"
              data-testid={'form-field-message'}
            />
            <Select
              name={'select1'}
              isMulti={true}
              options={CriticalTypeOptions}
              value={CriticalTypeOptions}
              onChange={option => {
                selectedCriticalType.current = option.map(
                  (el: any) => el.value,
                );
              }}
              placeholder="Selecione"
              label="Tipos de validação de críticas"
            />
            <br />
            <Select
              name={'select'}
              isMulti={true}
              options={ProductsOptions}
              value={ProductsOptions}
              onChange={option => {
                selectedProducts.current = option.map((el: any) => el.value);
              }}
              placeholder="Selecione"
              label="Tipos de validação"
            />

            <FormFooter>
              <Button
                variant="solid"
                style={{ marginTop: '1rem' }}
                type="submit"
                data-testid={'form-field-button'}
              >
                Salvar
              </Button>
              <Button
                variant="outline"
                color={'#C71F37'}
                style={{ marginTop: '1rem' }}
                onClick={() =>
                  setTimeout(() => {
                    back();
                  }, 300)
                }
              >
                Cancelar
              </Button>
            </FormFooter>
          </Form>
        </FormContainer>
      </Layout>
    </>
  );
};

export default Cadastro;
